import { useQuery } from "react-query";
import {
  fetchCollectionProducts,
  getProductCollectionByPublicId,
} from "../../Utils/SupabaseServices/ProductCollectionDatabase";
import { parseProductIds } from "../productCollection";
import { shouldShowToViewer } from "../HelperFunction/TimezoneDates";

export function useLoadPublicProductCollection(args: {
  collectionId?: string | null;
  username?: string | null;
  userId?: string | null;
  allowUnpublished?: boolean;
}) {
  const { collectionId, username, allowUnpublished = false } = args;
  const enabled = Boolean(collectionId && username);

  return useQuery(
    ["public-product-collection", collectionId, username, allowUnpublished],
    async () => {
      const collection = await getProductCollectionByPublicId({
        publicId: String(collectionId),
        username,
      });
      if (!collection) return { collection: null, products: [] as any[] };
      const status = String(
        collection.status_expiry ?? collection.status ?? ""
      )
        .toLowerCase()
        .trim();
      if (status === "deleted" || status === "hidden") {
        return { collection: null, products: [] as any[] };
      }
      if (!allowUnpublished && !shouldShowToViewer(collection)) {
        return { collection: null, products: [] as any[] };
      }
      const ids = parseProductIds(collection.post_ids);
      const products = collection.user_id
        ? await fetchCollectionProducts(
            String(username),
            String(collection.user_id),
            ids
          )
        : [];
      return { collection, products };
    },
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
}
